export default __webpack_public_path__ + "static/meet-the-team-slide-3-9cc9aba0c7dc63a75808e90f2d09f9ff.jpg";